<script>
import {
  deleteArquivoGrv,
  unificarDocumentosGrv,
  getDocumentoUnificadoGrv
} from '../../../../../domain/grv/services'

const TIPO_ARQUIVO_UNIFICADO = 10

export default {
  name: 'BtnUploadArquivoGrv',
  props: {
    grv: { type: Object, required: true },
    disabled: Boolean
  },
  data () {
    return { loading: false }
  },
  computed: {
    arquivoUnificadoGrv () {
      const arquivos = (this.grv && this.grv.arquivos) ? this.grv.arquivos : []
      return arquivos.find(a => a.tipo === TIPO_ARQUIVO_UNIFICADO)
    },
    labelBotaoUnificado () {
      return this.arquivoUnificadoGrv ? 'Visualizar documento' : 'Upload de documento'
    },
    classeBotaoUnificado () {
      return this.arquivoUnificadoGrv ? 'btn-info' : 'btn-default'
    },
    iconeBotaoUnificado () {
      return this.arquivoUnificadoGrv ? 'fa-file-pdf-o' : 'fa-upload'
    }
  },
  methods: {
    openUnificarInput () {
      if (this.loading || this.disabled) return
      if (this.$refs.uploadUnificarGrv) this.$refs.uploadUnificarGrv.click()
    },

    async uploadUnificado (e) {
      const files = Array.from(e.target.files || [])
      const allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png']
      const invalidFiles = files.filter(file => !allowedMimeTypes.includes(file.type))

      if (invalidFiles.length) {
        alert('Envie apenas arquivos PDF, JPG ou PNG.')
        this.clearUnificadoInput()
        return
      }

      if (!files.length) {
        this.clearUnificadoInput()
        return
      }

      if (this.arquivoUnificadoGrv) {
        alert('Este documento já foi unificado e não pode ser alterado.')
        this.clearUnificadoInput()
        return
      }

      const confirm = window.confirm('Os arquivos enviados (PDF, JPG e PNG) serão unificados em um único PDF e não poderão ser alterados. Deseja continuar?')
      if (!confirm) {
        this.clearUnificadoInput()
        return
      }

      this.loading = true
      this.$loaderOverlay.open().message('Unificando documentos...')

      try {
        const formData = new FormData()

        files.forEach((file, index) => {
          const prefix = String(index + 1).padStart(2, '0')
          const cleanName = file.name.replace(/^\d+\s*-\s*/, '')
          formData.append('files[]', file, `${prefix} - ${cleanName}`)
        })

        await unificarDocumentosGrv(this.grv.id, formData)

        this.$emit('reload')
        alert('Documentos unificados com sucesso.')
      } catch (error) {
        console.log('Erro ao unificar documentos: ', error)
        alert((error && error.response && error.response.data && error.response.data.error)
          ? error.response.data.error
          : 'Erro ao unificar documentos.'
        )
      } finally {
        this.clearUnificadoInput()
        this.loading = false
        this.$loaderOverlay.hide()
      }
    },

    async visualizarUnificado () {
      this.loading = true
      this.$loaderOverlay.open().message('Gerando link do documento...')

      try {
        const { data } = await getDocumentoUnificadoGrv(this.grv.id)

        if (!data || !data.url) {
          alert('Não foi possível obter o link do documento.')
          return
        }

        window.open(data.url, '_blank')
      } catch (error) {
        console.log('Erro ao obter documento unificado: ', error)
        alert((error && error.response && error.response.data && error.response.data.error)
          ? error.response.data.error
          : 'Erro ao visualizar documento.'
        )
      } finally {
        this.loading = false
        this.$loaderOverlay.hide()
      }
    },

    onClickUnificado () {
      if (this.loading || this.disabled) return
      if (this.arquivoUnificadoGrv) return this.visualizarUnificado()
      return this.openUnificarInput()
    },

    clearUnificadoInput () {
      if (this.$refs.uploadUnificarGrv) this.$refs.uploadUnificarGrv.value = ''
    },

    async deleteUnificado () {
      if (!this.arquivoUnificadoGrv) return

      const confirm = window.confirm('Tem certeza de que deseja excluir o documento unificado?')
      if (!confirm) return

      this.loading = true
      this.$loaderOverlay.open().message('Excluindo documento...')

      try {
        await deleteArquivoGrv(this.arquivoUnificadoGrv.id)
        this.$emit('reload')
        alert('Documento removido com sucesso.')
      } catch (error) {
        console.log('Ocorreu um erro ao remover o documento.', error)
        alert((error && error.response && error.response.data && error.response.data.error)
          ? error.response.data.error
          : 'Ocorreu um erro ao remover o documento.'
        )
      } finally {
        this.loading = false
        this.$loaderOverlay.hide()
      }
    }
  }
}
</script>

<template>
  <div>
    <button
      type="button"
      class="btn btn-block"
      :class="classeBotaoUnificado"
      :disabled="disabled || loading"
      @click="onClickUnificado"
    >
      <i class="fa m-r-sm" :class="iconeBotaoUnificado"></i>
      {{ labelBotaoUnificado }}
    </button>

    <button
      v-if="arquivoUnificadoGrv"
      type="button"
      class="btn btn-danger btn-block m-t-xs"
      :disabled="disabled || loading"
      @click="deleteUnificado"
    >
      <i class="fa fa-trash-o m-r-xs"></i>
      Excluir documento
    </button>

    <input
      type="file"
      ref="uploadUnificarGrv"
      multiple
      accept="application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png"
      @change="uploadUnificado"
      v-show="false"
    >
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// BtnUploadArquivoGrv.vue?1f266854